var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesMp4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8h12v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M14.292 17.753v1.845l1.255.884a.367.367 0 00.578-.302v-3.01a.367.367 0 00-.577-.303l-1.256.886zm-6.188-.484a.232.232 0 00-.229.234v.469c0 .13.103.234.23.234h.687v1.644c0 .386.306.7.684.7h3.674a.692.692 0 00.684-.7v-1.881c0-.387-.306-.7-.684-.7H8.104zm3.209-3.234a1.822 1.822 0 00-1.605-.985c-1.012 0-1.833.84-1.833 1.875 0 1.036.82 1.875 1.833 1.875h3.209c1.012 0 1.833-.84 1.833-1.875 0-1.036-.82-1.875-1.833-1.875-.696 0-1.294.4-1.604.985zm-2.521.89c0-.518.41-.938.916-.938.507 0 .917.42.917.938s-.41.937-.917.937a.927.927 0 01-.916-.937zm3.208 0c0-.518.41-.938.917-.938.506 0 .917.42.917.938-.001.518-.411.937-.917.937s-.917-.42-.917-.937z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#FF463D",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.834 5.328v-2.52l.853 1.672h.536l.883-1.682v2.53h.536V1.95h-.634L2.97 3.963 1.95 1.95h-.652v3.378h.536zm4.187 0V4.056h.673c.338 0 .605-.094.802-.283.197-.188.295-.445.295-.77s-.098-.582-.295-.77c-.197-.189-.464-.283-.802-.283H5.441v3.378h.58zm.615-1.73H6.02v-1.19h.615c.188 0 .33.05.426.151.096.101.144.249.144.444s-.048.343-.144.444c-.096.1-.238.15-.426.15zm3.612 1.73v-.702h.453v-.458h-.453V1.95h-.546L8.127 4.192v.434h1.6v.702h.521zm-.522-1.16H8.688l1.038-1.487v1.487z"
  })))));
}

export default SvgFileTypesMp4;